/**
* 企业实名认证
*/
<template>
	<div class="bg-gray-50 flex items-center justify-center py-5 px-4" style="padding-left: 5%; padding-right: 5%;">

		<!-- css样式库 -->
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
		<!-- 图标库 -->
		<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

		<div>
			<!-- 认证流程说明 start -->
			<div class="bg-white rounded-lg shadow-sm p-8">
				<h3 class="text-lg font-medium mb-6">
					<!-- 认证流程说明 -->
					{{ $t('language000124') }}
				</h3>
				<div class="grid grid-cols-3 gap-8">
					<div v-for="(step, index) in certificationSteps" :key="index" class="text-center">
						<div class="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-4">
							<i :class="step.icon" class="text-blue-600 text-xl"></i>
						</div>
						<h4 class="font-medium mb-2">{{ step.title }}</h4>
						<p class="text-gray-500 text-sm">{{ step.description }}</p>
					</div>
				</div>
			</div>
			<!-- 认证流程说明 end -->


			<!-- 企业认证 start -->
			<div class="w-full space-y-8 bg-white p-10 rounded-lg shadow-lg" style="margin-top: 20px;">
				<div class="text-center">
					<h1 class="text-3xl font-bold text-gray-900 mb-3">
						<!-- 企业实名认证 -->
						{{ $t('language000149') }}
					</h1>
					<p class="text-gray-600">
						<!-- 请填写企业相关信息，带 -->
						{{ $t('language000150') }}
						<span class="text-red-500">*</span>
						<!-- 为必填项 -->
						{{ $t('language000151') }}
					</p>
				</div>

				<form class="space-y-6" @submit.prevent="handleSubmit">
					<div>
						<label class="block text-sm font-medium text-gray-700">
							<!-- 企业名称 -->
							{{ $t('language000152') }}
							<span class="text-red-500">*</span>
						</label>
						<div class="mt-1">
							<input type="text" v-model="formData.companyName"
								class="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
								:class="{'border-red-500': errors.companyName}" :placeholder="$t('language000153')" />
							<p v-if="errors.companyName" class="mt-1 text-sm text-red-500">{{ errors.companyName }}</p>
						</div>
					</div>

					<div>
						<label class="block text-sm font-medium text-gray-700">
							<!-- 企业代码 -->
							{{ $t('language000154') }}
							<span class="text-red-500">*</span>
						</label>
						<div class="mt-1">
							<input type="text" v-model="formData.companyCode"
								class="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
								:class="{'border-red-500': errors.companyCode}" :placeholder="$t('language000155')" />
							<p v-if="errors.companyCode" class="mt-1 text-sm text-red-500">{{ errors.companyCode }}</p>
						</div>
					</div>

					<div>
						<label class="block text-sm font-medium text-gray-700">
							<!-- 营业执照照片 -->
							{{ $t('language000156') }}
							<span class="text-red-500">*</span>
						</label>
						<div class="mt-1">
							<div class="flex justify-center items-center w-full h-40 px-6 pt-5 pb-6 border-2 border-dashed rounded-md"
								:class="{'border-red-500': errors.license}" @click="triggerFileInput">
								<div class="space-y-1 text-center">
									<i v-if="!formData.license"
										class="fas fa-cloud-upload-alt text-4xl text-gray-400"></i>
									<img v-else :src="previewUrl" class="mx-auto h-32 w-auto object-contain"
										alt="营业执照预览" />
									<div class="text-sm text-gray-600">
										<label
											class="relative cursor-pointer rounded-md font-medium text-blue-600 hover:text-blue-500">
											<span>
												<!-- 点击上传文件 -->
												{{ $t('language000157') }}
											</span>
											<input ref="fileInput" type="file" class="sr-only" accept=".jpg,.png"
												@change="handleFileChange" />
										</label>
									</div>
									<p class="text-xs text-gray-500">
										<!-- 支持jpg、png格式，大小不超过5M -->
										{{ $t('language000158') }}
									</p>
								</div>
							</div>
							<p v-if="errors.license" class="mt-1 text-sm text-red-500">{{ errors.license }}</p>
						</div>
					</div>

					<div>
						<label class="block text-sm font-medium text-gray-700">
							<!-- 邮箱地址 -->
							{{ $t('language000159') }}
							<span class="text-red-500">*</span>
						</label>
						<div class="mt-1 space-y-2">
							<div class="flex gap-2">
								<input type="email" v-model="formData.email"
									class="flex-1 px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
									:class="{'border-red-500': errors.email}" :placeholder="$t('language000160')" />
								<button type="button"
									class="!rounded-button whitespace-nowrap px-4 py-2 text-sm border border-blue-500 text-blue-500 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
									@click="sendEmailCode" :disabled="emailCodeTimer > 0 || !formData.email">
									{{ emailCodeTimer > 0 ? `${emailCodeTimer} ${$t('language000161')}` : $t('language000105') }}
								</button>
							</div>
							<div v-if="showEmailCodeInput" class="relative">
								<input type="text" v-model="formData.emailCode"
									class="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
									:class="{'border-red-500': errors.emailCode}" :placeholder="$t('language000161')"
									maxlength="6" />
							</div>
							<p v-if="errors.email" class="mt-1 text-sm text-red-500">{{ errors.email }}</p>
							<p v-if="errors.emailCode" class="mt-1 text-sm text-red-500">{{ errors.emailCode }}</p>
						</div>
					</div>

					<div>
						<label class="block text-sm font-medium text-gray-700">
							<!-- 手机号码 -->
							{{ $t('language000163') }}
							<span class="text-red-500">*</span>
						</label>
						<div class="mt-1 space-y-2">
							<div class="flex gap-2">
								<input type="tel" v-model="formData.phone"
									class="flex-1 px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
									:class="{'border-red-500': errors.phone}" :placeholder="$t('language000006')" />
								<button type="button"
									class="!rounded-button whitespace-nowrap px-4 py-2 text-sm border border-blue-500 text-blue-500 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
									@click="sendPhoneCode" :disabled="phoneCodeTimer > 0 || !formData.phone">
									{{ emailCodeTimer > 0 ? `${emailCodeTimer} ${$t('language000161')}` : $t('language000105') }}
								</button>
							</div>
							<div v-if="showPhoneCodeInput" class="relative">
								<input type="text" v-model="formData.phoneCode"
									class="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
									:class="{'border-red-500': errors.phoneCode}" :placeholder="$t('language000164')"
									maxlength="6" />
							</div>
							<p v-if="errors.phone" class="mt-1 text-sm text-red-500">{{ errors.phone }}</p>
							<p v-if="errors.phoneCode" class="mt-1 text-sm text-red-500">{{ errors.phoneCode }}</p>
						</div>
					</div>

					<div class="pt-4">
						<button type="submit"
							class="!rounded-button w-full py-3 px-4 text-white text-lg font-medium transition-colors duration-200"
							:class="isFormValid ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-400 cursor-not-allowed'"
							:disabled="!isFormValid">
							<!-- 提交认证 -->
							{{ $t('language000165') }}
						</button>
					</div>
				</form>
			</div>
			<!-- 企业认证 end -->

		</div>
	</div>

</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';
	
	
	export default {
		mounted() {
			// 在生命周期钩子中获取路由参数

			const userLanguage = navigator.language || navigator.userLanguage; // 获取用户浏览器所配置的语言偏好
			const isLanguageSupported = this.$p_languages.includes(userLanguage); // 检查用户语言是否在支持的语言列表中
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage; // 如果语言受支持，则设置为用户语言，否则设置为默认语言
			//this.$i18n.locale = 'en'; // 设置为英语
		},
		data() {
			return {
				formData: {
					companyName: '',
					companyCode: '',
					license: null,
					email: '',
					emailCode: '',
					phone: '',
					phoneCode: '',
				},
				errors: {},
				emailCodeTimer: 0,
				phoneCodeTimer: 0,
				showEmailCodeInput: false,
				showPhoneCodeInput: false,
				previewUrl: '',
				previewUrlHttp: '',//营业执照地址
			};
		},
		computed: {
			isFormValid() {
				return (
					this.formData.companyName &&
					this.formData.companyCode &&
					this.formData.license &&
					this.formData.email &&
					this.formData.emailCode &&
					this.formData.phone &&
					this.formData.phoneCode &&
					Object.keys(this.errors).length === 0
				);
			},
			certificationSteps() {
				return [{
						icon: 'fas fa-file-alt',
						title: this.$t('language000125'), //准备材料
						description: this.$t('language000131'), //准备营业执照等认证所需材料
					},
					{
						icon: 'fas fa-upload',
						title: this.$t('language000127'), //提交审核
						description: this.$t('language000132'), //上传相关证件照片，填写企业信息提交审核
					},
					{
						icon: 'fas fa-check-circle',
						title: this.$t('language000129'), //完成认证
						description: this.$t('language000130'), //等待 1-3 个工作日完成审核，审核通过即可认证成功
					}
				];
			},
			//...
		},
		methods: {
			startEmailCodeTimer() {
				this.emailCodeTimer = 60;
				const timer = setInterval(() => {
					this.emailCodeTimer--;
					if (this.emailCodeTimer === 0) {
						clearInterval(timer);
					}
				}, 1000);
			},
			startPhoneCodeTimer() {
				this.phoneCodeTimer = 60;
				const timer = setInterval(() => {
					this.phoneCodeTimer--;
					if (this.phoneCodeTimer === 0) {
						clearInterval(timer);
					}
				}, 1000);
			},
			sendEmailCode() {
				if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)) {
					this.errors.email = '请输入正确的邮箱地址';
					return;
				}

				// 模拟发送邮箱验证码
				this.startEmailCodeTimer();
				this.showEmailCodeInput = true;
				delete this.errors.email;
				console.log('发送邮箱验证码到:', this.formData.email);
			},
			sendPhoneCode() {
				if (!/^1[3-9]\d{9}$/.test(this.formData.phone)) {
					this.errors.phone = '请输入正确的手机号码';
					return;
				}

				// 模拟发送手机验证码
				this.startPhoneCodeTimer();
				this.showPhoneCodeInput = true;
				delete this.errors.phone;
				console.log('发送手机验证码到:', this.formData.phone);
			},
			validateForm() {
				this.errors = {};

				if (!this.formData.companyName) {
					this.errors.companyName = '请输入企业名称';
				}

				if (!this.formData.companyCode) {
					this.errors.companyCode = '请输入企业代码';
				} else if (!/^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/.test(this.formData.companyCode)) {
					this.errors.companyCode = '请输入正确的统一社会信用代码';
				}

				if (!this.formData.license) {
					this.errors.license = '请上传营业执照照片';
				}

				if (!this.formData.email) {
					this.errors.email = '请输入邮箱地址';
				} else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)) {
					this.errors.email = '请输入正确的邮箱地址';
				}

				if (!this.formData.emailCode) {
					this.errors.emailCode = '请输入邮箱验证码';
				} else if (!/^\d{6}$/.test(this.formData.emailCode)) {
					this.errors.emailCode = '请输入6位数字验证码';
				}

				if (!this.formData.phone) {
					this.errors.phone = '请输入手机号码';
				} else if (!/^1[3-9]\d{9}$/.test(this.formData.phone)) {
					this.errors.phone = '请输入正确的手机号码';
				}

				if (!this.formData.phoneCode) {
					this.errors.phoneCode = '请输入手机验证码';
				} else if (!/^\d{6}$/.test(this.formData.phoneCode)) {
					this.errors.phoneCode = '请输入6位数字验证码';
				}

				return Object.keys(this.errors).length === 0;
			},
			triggerFileInput() {
				this.$refs.fileInput.click();
			},
			handleFileChange(event) {
				const file = event.target.files[0]; // 获取上传的文件

				if (file) {
					if (file.size > 5 * 1024 * 1024) {
						this.errors.license = '文件大小不能超过5M';
						return;
					}

					if (!['image/jpeg', 'image/png'].includes(file.type)) {
						this.errors.license = '只支持jpg、png格式的图片';
						return;
					}

					this.formData.license = file;
					this.previewUrl = URL.createObjectURL(file);
					delete this.errors.license;

					const formData = new FormData(); // 创建一个 FormData 对象
					formData.append("multipart", file); // 将文件添加到 FormData 对象中
					axios.post(this.$p_url_shop + '/api/front/upload/qiuiUploadImage?model=user&pid=1',
							formData, { //上传图片
								withCredentials: true,
								headers: {
									'Content-Type': 'multipart/form-data', //设置为上传文件的类型
								},
							})
						.then(response => {
							console.log("上传图片的返回：", response.data)
							const state = response.data.code; // 获取状态
							if (state === 200) { // 检查状态
								this.previewUrlHttp = response.data.data.url; //图片地址 营业执照
								console.log("营业执照：", this.$p_urlImage + this.previewUrlHttp)
							} else {
								alert("服务器错误:" + response.data.message)
							}
						})
						.catch(error => { // 请求失败时处理错误
							alert('请求失败:' + error);
							console.error('Error fetching data:', error);
						});

				}
			},
			handleSubmit() {
				if (this.validateForm()) {
					// 这里添加提交逻辑
					console.log('表单提交', this.formData);
				}
			},
		},
	};
</script>

<style scoped>
	input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	input[type="number"] {
		-moz-appearance: textfield;
	}
</style>